module.exports = __webpack_public_path__ + "img/gopi.d6cdbdda.jpg";